<template>
  <div class="date-selection">
    <ul class="dates">
      <li v-for="date, dateIndex in availableDates" :key="dateIndex" class="dates__list-item">
        <div class="dates__list-header">
          <span class="dates__list-item-date">
            {{ formatDate(date.date) }}
          </span>
          <span class="dates__list-item-week-day">
            {{ date.weekDay }}
          </span>
        </div>
        <ul v-if="hasTimes(date)" class="times__list">
          <li v-for="timeItem, timeIndex in date.times" :key="timeIndex" class="times__list-item">
            <input :value="`${date.date}T${timeItem.value}.000+0000`" :id="`time-${dateIndex}-${timeIndex}`" type="radio" name="time" />
            <label @click="$emit('setSelectedDateAndTime', timeItem.slot)" :for="`time-${dateIndex}-${timeIndex}`">
              {{ timeItem.label }}
            </label>
            <v-icon x-small>
              mdi-check
            </v-icon>
          </li>
        </ul>
        <p v-else class="times__list-empty mb-0">
          {{ emptyTimesLabel }}
        </p>
      </li>
    </ul>

    <p v-if="hasNoAvailableDates" class="dates__no-dates-available mb-0">
      {{ noAvailableDatesLabel }}
    </p>
  </div>
</template>

<script>
import moment from 'moment-timezone'

export default {
  name: 'SelectAvailableDatesList',

  props: {
    availableDates: {
      type: Array,
      default: () => [],
    },

    loadingAvailableDates: {
      type: Boolean,
      default: false,
    },

    currentWeekStart: {
      type: String,
      default: '',
    },

    currentWeekEnd: {
      type: String,
      default: '',
    },
  },

  computed: {
    hasNoAvailableDates() {
      return this.availableDates?.length === 0 && !this.loadingAvailableDates
    },
  },

  methods: {
    formatDate(date) {
      try {
        return moment(date).format('DD/MM')
      } catch (e) {
        return '--/--'
      }
    },

    hasTimes(date) {
      return date.times?.length > 0
    },
  },

  data() {
    return {
      emptyTimesLabel: this.$t('appointment.confirmAppointment.availableDates.emptyTimes'),
      noAvailableDatesLabel: '',
    }
  },

  watch: {
    currentWeekStart: {
      immediate: true,
      handler() {
        this.noAvailableDatesLabel = this.$t('appointment.confirmAppointment.availableDates.noAvailableDates', {
          start: this.formatDate(this.currentWeekStart),
          end: this.formatDate(this.currentWeekEnd),
        })
      },
    },
  },
}
</script>
